import { createI18n } from 'vue-i18n';
import en from './en';
import ru from './ru';

export type Locale = 'en' | 'ru';
const LANG_KEY = 'emcity_guest_lang';

function initialLocale(): Locale {
  const saved = localStorage.getItem(LANG_KEY);
  if (saved === 'en' || saved === 'ru') return saved;
  return navigator.language?.startsWith('ru') ? 'ru' : 'en';
}

// Russian plural forms: 1 ночь, 2–4 ночи, 5+ ночей.
function ruPlural(choice: number, choicesLength: number) {
  if (choicesLength < 3) return choice === 1 ? 0 : 1;
  const mod10 = choice % 10;
  const mod100 = choice % 100;
  if (mod10 === 1 && mod100 !== 11) return 0;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 1;
  return 2;
}

export const i18n = createI18n({
  legacy: false,
  locale: initialLocale(),
  fallbackLocale: 'en',
  messages: { en, ru },
  pluralRules: { ru: ruPlural },
});

export function setLocale(locale: Locale) {
  i18n.global.locale.value = locale;
  localStorage.setItem(LANG_KEY, locale);
  document.documentElement.lang = locale;
}

export function hasSavedLocale(): boolean {
  return !!localStorage.getItem(LANG_KEY);
}

export function currentLocale(): Locale {
  return i18n.global.locale.value as Locale;
}
